import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const DOMCilinderOutlined: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M13.5 15H8.5V18H3V16H6.5V13H15.5V16H21V18H13.5V15ZM21 8H15.5V11H6.5V8H3V18L2.7959 17.9893C1.78722 17.887 1 17.0357 1 16V8C1 6.89543 1.89543 6 3 6H8.5V9H13.5V6H21C22.1046 6 23 6.89543 23 8V16C23 17.1046 22.1046 18 21 18V8Z"
      fill="currentColor"
    />
    <path
      d="M20.25 8V16H18.75V8H20.25ZM5 13.25C5.41421 13.25 5.75 13.5858 5.75 14C5.75 14.4142 5.41421 14.75 5 14.75H4.5C4.08579 14.75 3.75 14.4142 3.75 14C3.75 13.5858 4.08579 13.25 4.5 13.25H5ZM17.5 13.25C17.9142 13.25 18.25 13.5858 18.25 14C18.25 14.4142 17.9142 14.75 17.5 14.75H17C16.5858 14.75 16.25 14.4142 16.25 14C16.25 13.5858 16.5858 13.25 17 13.25H17.5ZM5 9.25C5.41421 9.25 5.75 9.58579 5.75 10C5.75 10.4142 5.41421 10.75 5 10.75H4.5C4.08579 10.75 3.75 10.4142 3.75 10C3.75 9.58579 4.08579 9.25 4.5 9.25H5ZM17.5 9.25C17.9142 9.25 18.25 9.58579 18.25 10C18.25 10.4142 17.9142 10.75 17.5 10.75H17C16.5858 10.75 16.25 10.4142 16.25 10C16.25 9.58579 16.5858 9.25 17 9.25H17.5Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DOMCilinderOutlined;
